export default "__VITE_ASSET__Bt8GdO7n__"